import { Box } from "@mui/material";
import { ResponsiveImage } from "src/components-mui/base/responsive-image/responsive-image";
import { WfHeading } from "src/components-mui/base/wf-heading/wf-heading";
import { SimpleRichText } from "src/components-mui/common/rich-text/simple-rich-text";
import { Container } from "src/components-mui/layout/container";
import { HeroSlideCtaBox, IHeroSlideCtaButton } from "src/components-mui/modules/hero-module/components/hero-slide-cta-box";
import { HeroSlideRegisterBox } from "src/components-mui/modules/hero-module/components/hero-slide-register-box";
import { IImage } from "src/types/common";
import { CONTAINER_HEADER_CLASS } from "../constants";

type HeroSlideVariant = "cta" | "register";
type RegisterButtonColor = "green" | "gray";
export interface IHeroSliderSlideProps {
    title: string;
    description: string;
    desktopImage: IImage;
    mobImage: IImage;
    tabImage: IImage;
    registerButtonColor?: RegisterButtonColor;
    isTitleFontSizeBig?: boolean;
    variant?: HeroSlideVariant;
    cta1?: IHeroSlideCtaButton | null;
    cta2?: IHeroSlideCtaButton | null;
    displayTitleAsH1?: boolean;
    delay?: number; // ms, for per-slide autoplay
}

export const HeroSliderSlide = ({
    title,
    description,
    displayTitleAsH1,
    isTitleFontSizeBig,
    desktopImage,
    variant,
    mobImage,
    tabImage,
    registerButtonColor,
    cta1,
    cta2,
}: IHeroSliderSlideProps) => {
    return (
        <Box sx={{ flex: "0 0 100%", minWidth: 0 }} position="relative">
            <Box width="100%" height="100%" overflow="hidden">
                <ResponsiveImage
                    baseUrl={desktopImage.url}
                    alt={desktopImage?.alt}
                    width="100%"
                    height="100%"
                    srcSet={[
                        {
                            queryParams: { w: 768, h: 720 },
                            url: mobImage?.url ? mobImage.url : desktopImage.url,
                        },
                        {
                            queryParams: { w: 992, h: 720 },
                            url: tabImage?.url ? tabImage.url : desktopImage.url,
                        },
                        {
                            queryParams: { w: 1200, h: 650 },
                            url: desktopImage.url,
                        },
                        {
                            queryParams: { h: 760 },
                            url: desktopImage.url,
                        },
                    ]}
                    sx={{
                        minHeight: "100%",
                        objectFit: "cover",
                        objectPosition: "right center",
                    }}
                    loading="eager"
                />
            </Box>
            <Box
                className={CONTAINER_HEADER_CLASS}
                width="100%"
                height="100%"
                position="absolute"
                top="0"
                left="0"
                display="flex"
                alignItems={["baseline", "center"]}
            >
                <Container>
                    <Box maxWidth={["100%", "300px", "360px", "450px"]} pt={[4, 0]}>
                        <WfHeading
                            fontSize={isTitleFontSizeBig ? { xs: "4xl", md: "5xl" } : { xs: "3xl", md: "4xl" }}
                            component={displayTitleAsH1 ? "h1" : "h2"}
                        >
                            {title}
                        </WfHeading>
                        <SimpleRichText mt={2} mb={3} text={description} />
                        {variant === "register" && <HeroSlideRegisterBox registerButtonColor={registerButtonColor} />}
                        {variant === "cta" && <HeroSlideCtaBox cta1={cta1} cta2={cta2} />}
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};
